// extracted by mini-css-extract-plugin
export default {"aboutParent":"about_aboutParent__FIgRW","aboutContainer":"about_aboutContainer__qeZDj","title":"about_title__Jr0Ci"};